var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessemoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "#88C54B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "white",
    fillOpacity: 0.48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    stroke: "#70AC17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 53C45.3888 53 53 45.3888 53 36C53 26.6112 45.3888 19 36 19C26.6112 19 19 26.6112 19 36C19 45.3888 26.6112 53 36 53ZM36 56C47.0457 56 56 47.0457 56 36C56 24.9543 47.0457 16 36 16C24.9543 16 16 24.9543 16 36C16 47.0457 24.9543 56 36 56Z",
    fill: "#70AC17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4858 43.5C31.5028 44.9377 33.2402 46.5 36 46.5C38.7598 46.5 40.4972 44.9377 41.5142 43.5H30.4858ZM27.2555 43.9745C26.2992 42.2123 27.7583 40.5 29.3874 40.5H42.6126C44.2417 40.5 45.7008 42.2123 44.7445 43.9745C43.6967 45.9055 41.0611 49.5 36 49.5C30.9389 49.5 28.3033 45.9055 27.2555 43.9745Z",
    fill: "#70AC17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31C32 32.6569 30.6569 34 29 34C27.3431 34 26 32.6569 26 31C26 29.3431 27.3431 28 29 28C30.6569 28 32 29.3431 32 31Z",
    fill: "#70AC17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31C46 32.6569 44.6569 34 43 34C41.3431 34 40 32.6569 40 31C40 29.3431 41.3431 28 43 28C44.6569 28 46 29.3431 46 31Z",
    fill: "#70AC17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessemoji);
export default __webpack_public_path__ + "static/media/successemoji.b48b68096f59dafebdeda03178a9a9f6.svg";
export { ForwardRef as ReactComponent };